import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import { parseOutcomeData } from '../helpers';
import type { PostCompanyRequestType, PostCompanyResponseType } from '../types';

export const postCompany = async ({
  pathParams: { boardId },
  bodyParams,
}: PostCompanyRequestType) => {
  const url = `/boards/${boardId}/company`;
  const company = parseOutcomeData(bodyParams || {});

  const { data } = await apiAuthClient.post<PostCompanyResponseType>(
    url,
    company,
  );

  return data.data;
};
